import type { WorkspaceTab } from '@/hooks/useWorkspaceTabs'

export interface WorkspaceTabItem {
  id: WorkspaceTab
  label: string
  badge?: number | string
  tone?: 'default' | 'accent' | 'warn'
}

interface Props {
  tabs: WorkspaceTabItem[]
  active: WorkspaceTab
  onChange: (id: WorkspaceTab) => void
}

export function WorkspaceTabs({ tabs, active, onChange }: Props) {
  return (
    <nav className="ws-tabs" role="tablist" aria-label="Workspace">
      {tabs.map((t) => {
        const selected = t.id === active
        return (
          <button
            key={t.id}
            type="button"
            role="tab"
            id={`tab-${t.id}`}
            aria-selected={selected}
            aria-controls={`panel-${t.id}`}
            tabIndex={selected ? 0 : -1}
            className={`ws-tab${selected ? ' on' : ''}${t.tone === 'accent' ? ' tone-accent' : ''}${t.tone === 'warn' ? ' tone-warn' : ''}`}
            onClick={() => onChange(t.id)}
          >
            <span className="ws-tab-label">{t.label}</span>
            {t.badge !== undefined && t.badge !== 0 && t.badge !== '0' ? (
              <span className="ws-badge">{t.badge}</span>
            ) : null}
          </button>
        )
      })}
    </nav>
  )
}
